var base = require('kiosk/kiosk');
var tabNav = require('./../../app/components/tab-navigation.vue');
var tabState = require('./../../spark/mixins/tab-state.js');

Vue.component('spark-kiosk', {
    mixins: [base, tabNav, tabState],

    data () {
        return {
            activeTab: null
        }
    },

    mounted() {
        this.activeTab = 'metrics';
    },

    watch: {
        activeTab(hash) {
            $('[href="#'+hash+'"]').click();
        }
    },
});
